export default {
  title: '身份验证',
  desc: '根据要求，用户需要绑定保时捷内部员工 ID，若不完成员工 ID 绑定，将无法进入 Porscheopolis ，为了您的使用体验，请填写下方身份信息，完成员工 ID绑定。\n*注意：请填写英文名并区分字母大小写及空格。',
  namePlaceholder: '请填写员工真实姓名',
  jobNumberPlaceholder: '请填写员工ID',
  secretPlaceholder: '请填写您的秘钥',
  confirm: '确定',
  nameLimit: '名称至少两位字符',
}
